import { Observable } from 'rxjs';
import { DataDescriptor } from '../../models/data-descriptor';
import { DynamicModification } from '../../models/dynamic-modification';
import { DynamicModificationProperties } from '../../models/dynamic-modification-properties';
import { DynamicModificationTarget } from '../../models/dynamic-modification-target';
import { VisibilityCriteria } from '../../models/visibility-criteria/visibility-criteria';
import { ViewerService } from '../../services/viewer.service';
import { Action } from './action';
import { AddDmOperation } from './operations/add-dm-operation';
import { DeleteDmOperation } from './operations/delete-dm-operation';
import { Operation } from './operations/operation';


export class DeleteDmAction extends Action {
    names: Array<string>;
    viewerService: ViewerService;

    protected operation: Operation;
    protected reverseOperation: Operation;

    private appeazUrl: string;
    private stepId: string;
    private idAppeaz: number;
    private appeazRole: string;
    private readonly dynamicModifications: Array<DynamicModification>;

    private readonly ids: Array<number>
    private readonly isPhotoImport: boolean;

    constructor(viewerService: ViewerService, appeazUrl: string, stepId: string,
        idAppeaz: number, appeazRole: string, dynamicModifications: Array<DynamicModification>, isPhotoImport: boolean) {
        super();
        this.viewerService = viewerService;

        this.names = [];
        dynamicModifications.forEach(dynamicModification => {
            this.names.push(dynamicModification.modificationTarget.label);
        });

        this.appeazUrl = appeazUrl;
        this.stepId = stepId;
        this.idAppeaz = idAppeaz;
        this.appeazRole = appeazRole;
        this.ids = [];
        dynamicModifications.forEach(dynamicModification => {
            this.ids.push(dynamicModification.id);
        });
        this.isPhotoImport = isPhotoImport;
        this.dynamicModifications = [];

        this.operation = new DeleteDmOperation(this.viewerService, this.names[0], idAppeaz, appeazUrl, appeazRole, stepId, this.ids, isPhotoImport);
    }


    // Parameters should be used once the API returns the required informations for building the reverse operation
    buildReverseOperation(deletedDM: any) {
        if (!Array.isArray(deletedDM)) {
            deletedDM = [deletedDM];
        }
        deletedDM.forEach(dynamicModificationtocreate => {
            const currentDynamicModification = new DynamicModification();
            currentDynamicModification.id = dynamicModificationtocreate.id;
            currentDynamicModification.priorityOrder = dynamicModificationtocreate.priorityOrder;
            currentDynamicModification.modificationTarget = new DynamicModificationTarget();
            currentDynamicModification.modificationTarget.label = dynamicModificationtocreate.modificationTarget.label;
            currentDynamicModification.modificationTarget.infoText = dynamicModificationtocreate.modificationTarget.infoText;
            currentDynamicModification.modificationTarget.properties = new DynamicModificationProperties();
            currentDynamicModification.modificationTarget.properties.elementType = dynamicModificationtocreate.modificationTarget.properties.elementType;
            currentDynamicModification.modificationTarget.properties.editable = dynamicModificationtocreate.modificationTarget.properties.editable;
            currentDynamicModification.modificationTarget.properties.required = dynamicModificationtocreate.modificationTarget.properties.required;
            currentDynamicModification.modificationTarget.properties.textMaxLength = dynamicModificationtocreate.modificationTarget.properties.textMaxLength;
            currentDynamicModification.modificationTarget.properties.regExpPattern = dynamicModificationtocreate.modificationTarget.properties.regExpPattern;
            currentDynamicModification.modificationTarget.properties.defaultValue = dynamicModificationtocreate.modificationTarget.properties.defaultValue;
            currentDynamicModification.modificationTarget.properties.anchorReference = dynamicModificationtocreate.modificationTarget.properties.anchorReference;

            currentDynamicModification.modificationTarget.properties.visibilityCriteria = new VisibilityCriteria();
            if (dynamicModificationtocreate.modificationTarget.properties.visibilityCriteria !== undefined) {
                const visbilityCriteriaJSON = dynamicModificationtocreate.modificationTarget.properties.visibilityCriteria;
                currentDynamicModification.modificationTarget.properties.visibilityCriteria.conditions =
                    visbilityCriteriaJSON.conditions;
                currentDynamicModification.modificationTarget.properties.visibilityCriteria.visibilityMode =
                    visbilityCriteriaJSON.visibilityMode;
            }
            currentDynamicModification.modificationTarget.dataDescriptor = new DataDescriptor();
            if (dynamicModificationtocreate.modificationTarget.dataDescriptor !== undefined && dynamicModificationtocreate.modificationTarget.dataDescriptor !== null) {
                currentDynamicModification.modificationTarget.dataDescriptor.name = dynamicModificationtocreate.modificationTarget.dataDescriptor.name;
                currentDynamicModification.modificationTarget.dataDescriptor.datatype = dynamicModificationtocreate.modificationTarget.dataDescriptor.dataType;
            }
            if (dynamicModificationtocreate.modificationTarget.values) {
                currentDynamicModification.modificationTarget.values = dynamicModificationtocreate.modificationTarget.values;
            }

            // EAZ-1026
            currentDynamicModification.modificationTarget.labelTranslations = dynamicModificationtocreate.modificationTarget.labelTranslations;
            currentDynamicModification.modificationType = dynamicModificationtocreate.modificationType;
            currentDynamicModification.anchorReference = dynamicModificationtocreate.anchorReference;
            this.dynamicModifications.push(currentDynamicModification);
        })
        const priority = this.dynamicModifications[this.dynamicModifications.length - 1].priorityOrder;
        this.name = this.dynamicModifications[this.dynamicModifications.length - 1].modificationTarget.label;


        this.reverseOperation = new AddDmOperation(this.viewerService, this.name, this.idAppeaz, this.appeazUrl, this.appeazRole,
            this.stepId, [...this.dynamicModifications].reverse(), priority, undefined, false);
    }

    do(): Observable<any> {
        return super.do();
    }

    undo(): Observable<any> {
        return super.undo();
    }

}
